

export const RESPONSE_STATUS = {
   Unset:'Unset',
   Loading:'Loading',
   Succeeded: 'Succeeded',
   Error: 'Error'
}

export const METHOD_TYPE = {
  get: 'GET',
  post: 'post',
  delete: 'DELETE',
  put: 'PUT',
  patch: 'PATCH'
};

export const PUBLIC_TRANSPORT_LIMIT_DATE = 14;